import { Component, Input } from '@angular/core';

export interface ConfigurationBreadcrumb {
  label: string;
  /** Omit on the final (current) crumb so it renders as plain text. */
  routerLink?: string;
}

/**
 * Shared shell for every /configuration/* screen.
 *
 * Owns the sidebar + content grid, the breadcrumb trail and the sticky page
 * header so individual pages only supply their own body. Content is projected
 * through three optional slots:
 *
 *   [configPageActions]: header buttons (right side of the title row)
 *   [configPageTabs]:    a nav/tab bar pinned directly under the header
 *   (default):           the page body
 */
@Component({
  selector: 'app-configuration-page',
  templateUrl: './configuration-page.component.html',
  styleUrls: ['./configuration-page.component.css'],
})
export class ConfigurationPageComponent {
  /** Small uppercase label above the title, e.g. "Payments". */
  @Input() eyebrow?: string;

  /** Page title. */
  @Input() title = '';

  /** Supporting sentence under the title. */
  @Input() description?: string;

  /**
   * Trail shown above the title. "Configuration" is prepended automatically,
   * so pages pass only their own crumbs.
   */
  @Input() breadcrumbs: ConfigurationBreadcrumb[] = [];

  /** Set false for pages that manage their own full-bleed body padding. */
  @Input() contentPadding = true;

  get trail(): ConfigurationBreadcrumb[] {
    return [{ label: 'Configuration', routerLink: '/configuration' }, ...this.breadcrumbs];
  }
}
